import React, { useMemo } from "react";
import { Grid as GridBase, Paper, Typography } from "@mui/material";

import { CurrencyFormateText } from "@/components/CurrencyFormat";
import RpSvgIcon from "@/components/icons/RpSvgIcon";

type ExpendTotalBudgetProps = {
  values: {
    selectedLoc?: Record<
      string | number,
      {
        extend_budget?: string | number;
      }
    >;
  };
};

const Grid = GridBase as React.ComponentType<Record<string, any>>;

function ExpendTotalBudget({ values }: ExpendTotalBudgetProps) {
  const totalBudget = useMemo(() => {
    const { selectedLoc } = values;
    if (!selectedLoc || !Object.keys(selectedLoc).length) return 0;

    return Object.values(selectedLoc)?.reduce((acc, curr) => {
      return acc + Number(curr.extend_budget);
    }, 0);
  }, [values]);

  return (
    <Paper className="p-3" elevation={2}>
      <Grid container spacing={4} alignItems="center" justifyContent="flex-end">
        <Grid item xs={12} md={6}>
          <Typography variant="h6">Your Campaign Total Budget</Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography
            variant="body2"
            sx={(theme) => ({
              border: `1px solid ${theme.palette.primary.main}`,
              py: 1,
              px: 2,
              borderRadius: "var(--radius-container)",
              display: "flex",
              alignItems: "center",
              gap: 1,
            })}
          >
            <RpSvgIcon name="money" size={25} color="primary" />

            <CurrencyFormateText value={totalBudget} suffix="USD" />
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
}

export default ExpendTotalBudget;
